import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { AvailablePostCampaignInfoDto } from 'viewup-api/v2';
import type { PostCampaign } from '../../model/types';

export type getPostCampaignsReq = {
  snsAccountUuid: string;
};

export type getPostCampaignRes = {
  campaigns: PostCampaign[];
};

export const getPostCampaigns = async (): Promise<getPostCampaignRes> => {
  const { data: response } = await serviceApi.campaign.getAvailablePostCampaign(
    withServiceRequestDefaults({
      searchType: 'apply',
    }),
  );
  return {
    campaigns: dtoToDomain(response.data.campaigns),
  };
};

const dtoToDomain = (data: AvailablePostCampaignInfoDto[]): PostCampaign[] => {
  return data.map(({ description, name, postCampaignUuid, rewardPoint, typeCode, ...options }) => {
    return {
      campaignName: name,
      campaignUuid: postCampaignUuid,
      description,
      options: {
        text: options?.minimumContentLength,
        picture: options?.minimumImageCount,
        ...(options?.containsVideos && { video: true }),
        keyword: true,
        hashTag: true,
        ...(options?.containsPlace && { place: true }),
        ...(options?.containsLink && { link: true }),
      },
      rewardPoint,
      typeCode,
    };
  });
};
